export default __webpack_public_path__ + "static/media/nice_job.924e3934.mp3";